import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { DisplayPageType } from "@faire/web-api--source/indigofair/data/DisplayPageType";
var DEFAULT_DISPLAY_PAGE_TYPE = undefined;
export var getSamplesRequestModalSourceFromDisplayPageType = function(displayPageType) {
    if (displayPageType === undefined) {
        return DEFAULT_DISPLAY_PAGE_TYPE;
    }
    var _samplesRequestModalSourceFromDisplayPageTypeMap_displayPageType;
    return (_samplesRequestModalSourceFromDisplayPageTypeMap_displayPageType = samplesRequestModalSourceFromDisplayPageTypeMap[displayPageType]) !== null && _samplesRequestModalSourceFromDisplayPageTypeMap_displayPageType !== void 0 ? _samplesRequestModalSourceFromDisplayPageTypeMap_displayPageType : DEFAULT_DISPLAY_PAGE_TYPE;
};
var _obj;
var samplesRequestModalSourceFromDisplayPageTypeMap = (_obj = {}, _define_property(_obj, DisplayPageType.DISPLAY_PAGE_TYPE_UNKNOWN, DEFAULT_DISPLAY_PAGE_TYPE), _define_property(_obj, DisplayPageType.HOMEPAGE, "HOME"), _define_property(_obj, DisplayPageType.CATEGORY_PAGE, "C1"), _obj);
